<template>
    <PageContent classes="dashboard">
        <PageTitle>Dashboard</PageTitle>
        <NotReady v-if="!ready" />
        <div v-else class="container">
          <div class="row">
            <div class="col" v-html="content" v-if="this.$store.state.localStorage.user['Show_Dashboard']"></div>
            <div class="col text-center  pt-3 pb-3" v-else><img id="logo" alt="Kitchen Fresh Foods" src="../assets/kf-foods-logo.png" class="mw-100" /></div>
          </div>
        </div>
    </PageContent>
  </template>
  
  <script>
  import PageContent from '@/components/PageContent.vue';
  import NotReady from '@/components/NotReady.vue';
  import PageTitle from '@/components/PageTitle.vue';
    // import '@/assets/css/block-library.scss'
  // import '@/assets/css/coblocks.scss'


  export default {
    name: 'Dashboard',
    components: {PageContent, PageTitle,  NotReady},
    data(){
        return {
            ready:false,
            content:''
        }
    },
    async mounted(){
        if(this.$store.state.localStorage.user['Show_Dashboard']){
          let req = await fetch(`https://kitchenfreshfoods.com/wp-json/wp/v2/pages/850`);
          let res = await req.json();
          this.content = res.content.rendered.replace(/\n+/gi, '');
        }
                        // console.log(this.$root.getCustomerValue('City'));
         
      
        this.ready = true;
    },
    methods:{
    },
  }
  </script>
  <style lang="scss" >
    .dashboard{
      *{
        line-height:1.4;
      }
      .container{
        max-width: 1000px !important;
      }
      img{
        width: auto !important;
        height: auto !important;
        max-width: 100%;
        max-height: 100%;
      }
    }
  </style>
  